import { useCallback } from 'react';
import _ from 'underscore';
import {
  supportedVideoExtensions,
} from '../model/constants';

const checkExtension = (supportedList, ext) => {
  if (ext && !_.isEmpty(supportedList)) {
    const extToCheck = ext.toLowerCase();

    return _.chain(supportedList)
      .map(item => item.toLowerCase())
      .contains(extToCheck)
      .value();
  }

  return false;
};

export const useCustomizedHandlerOptions = () => {
  const getCustomizedHandlerOptions = useCallback(({ ext } = {}) => ({
    isVideo: checkExtension(supportedVideoExtensions, ext),
  }), []);

  return {
    getCustomizedHandlerOptions,
  };
};
